import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  getDiffKey,
  getDiffText,
  groupAllLabelI18nKey,
  type GroupAndAll,
} from '~/utils'

import { useTabulatedGroups } from '../hooks/useTabulatedGroups'
import { useAtomValueContext } from '../providers/AtomsProvider'
import { type GroupsDiffColumnKey } from '../utils'

import { useGroupAndAllNameMap } from './useGroupAndAllNameMap'

type GroupSortItem = {
  columnKey: GroupAndAll | GroupsDiffColumnKey
  label: string
}

export const useGroupSortItems = () => {
  const { t } = useTranslation()
  const tabulatedGroups = useTabulatedGroups()
  const groupAndAllNameMap = useGroupAndAllNameMap()
  const groupsDiffs = useAtomValueContext('groupsDiffs')

  return React.useMemo<GroupSortItem[]>(
    () => [
      { columnKey: 'all', label: t(groupAllLabelI18nKey) },
      ...tabulatedGroups.map((group) => ({
        columnKey: group,
        label: groupAndAllNameMap[group],
      })),
      ...groupsDiffs.map((groupsDiff) => ({
        columnKey: getDiffKey(groupsDiff),
        label: getDiffText(groupsDiff, {
          textFn: (item) => groupAndAllNameMap[item],
          separator: '',
        }),
      })),
    ],
    [groupAndAllNameMap, groupsDiffs, t, tabulatedGroups],
  )
}
